// src/components/Card.jsx
import React from 'react';
import './Card.css';

const Card = ({ title, subtitle = "", children, className, ...props }) => {
  return (
    <div className={`card ${className || ''}`} {...props}>
      {title && <h2 className="card-title">{title}</h2>}
      {<p className="card-subtitle">{subtitle}</p>}
      {children}
    </div>
  );
};

export default Card;
